import { memo, useEffect, useRef, useState } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { useTranslation } from "react-i18next";
import { TitleInput } from "shared/cx-components/cx-components.style";
import { CustomizationColors, GenericButton } from "shared/ui-basics";
import { ColorPickerVertical } from "shared/ui-basics/ui-components/ColorPickerVertical";
import styled from "styled-components/macro";
import TaxonomyItem from "./TaxonomyItem";
import { ActionConfirmModal } from "shared/modals";
import { useModal } from "use-modal-hook";
import Drag from "shared/Drag-Drop/components/Drag";
interface TaxonomyListItemProps {
	item: any;
	onUpdate: (params: any) => void;
	onDelete: (params: any) => void;
	showDot?: boolean;
	isEditAllowed?: boolean;
	defaultColor?: { color: string; backgroundColor: string };
}

const TaxonomyListItem: React.FC<TaxonomyListItemProps> = ({ item, onUpdate, onDelete, showDot = false, isEditAllowed = true, defaultColor }) => {
	const { t } = useTranslation();
	const target = useRef(null);

	const [show, setShow] = useState(false);
	const [name, setName] = useState(item?.name);
	const [colorCode, setColorCode] = useState(item?.colorCode);
	const [placement, setPlacement] = useState("right");

	useEffect(() => {
		const handleResize = () => {
			const isEnoughSpaceForRight = window.innerWidth > 1750;
			setPlacement(isEnoughSpaceForRight ? "right" : "auto");
		};

		handleResize();

		window.addEventListener("resize", handleResize);

		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const handleUpdate = () => {
		onUpdate({ updatedItem: { ...item, name, colorCode }, modifiedAttribNames: ["name", "colorCode"] });
	};
	const [showModalDelete] = useModal(ActionConfirmModal, {
		title: t("ASPX_145"),
		bodyContent: "DELETE_PERMANENT_GENERIC",
		Action: () => onDelete({ item }),
		actionBtnText: "ASPX_13",
	});
	const openPopover = (visible) => {
		if (isEditAllowed) setShow(visible);
		if (!visible && (name !== item?.name || colorCode !== item?.colorCode)) {
			handleUpdate();
		}
	};

	const popover = (
		<PopOverCustom>
			<Menu>
				<InputContainer2>
					<TitleInput
						value={name}
						title={name}
						color="#262626"
						fontSize="14px"
						fontWeight={400}
						className="ps-2"
						name="name"
						noborder="true"
						placeholder={t("NEW_ITEM")}
						onChange={(e) => setName(e.target.value)}
					/>
				</InputContainer2>
				<ColorsContainer>
					<ColorPickerVertical variant="taxonomy" onSelect={({ color }) => setColorCode(color)} selectedColor={colorCode} />
				</ColorsContainer>
				<MenuFooter>
					<div className="mt-2">
						<GenericButton
							variant="dark-outline"
							icon="trash"
							iconClassName="me-2"
							size="s"
							onClick={showModalDelete}
							tooltip={item?.isUsed ? true : false}
							tooltipText={t("VALUE_IS_USED")}
							disabled={item?.isUsed === true || item?.isCustom === false}>
							{t("CS_45")}
						</GenericButton>
					</div>
				</MenuFooter>
			</Menu>
		</PopOverCustom>
	);

	const { color, backgroundColor } = CustomizationColors[colorCode] || defaultColor || { color: "#333", backgroundColor: colorCode };

	return (
		<Drag
			key={item.id}
			id={item.id}
			handleStyle={{
				cursor: "grab",
				position: "absolute",
				top: "14px",
				left: "4px",
				zIndex: 1,

			}}>
			<Container>
				<TaxonomyItem text={item.name} color={color} backgroundColor={backgroundColor} showDot={showDot} />
				{isEditAllowed && (
					<OverlayTrigger show={show} onToggle={openPopover} overlay={popover} trigger={["click"]} rootClose placement={placement}>
						<div>
							<GenericButton ref={target} variant="light-link" onClick={null} icon="ellipsis" />
						</div>
					</OverlayTrigger>
				)}
			</Container>
		</Drag>
	);
};

export default TaxonomyListItem;

const ActionsContainer = styled.div`
	visibility: hidden;
	position: relative;
`;

const Container = styled.div`
	margin-top: 8px;
	padding: 8px 18px;
	
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	border-radius: 4px;
	:hover {
		background-color: #f1f5f9;
		cursor: pointer;
	}
	:hover ${ActionsContainer} {
		visibility: visible;
	}
`;

const Menu = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

const InputContainer2 = styled.div`
	width: 100%;
	height: 41px;
	border: 1px solid #333;
	border-radius: 4px;
`;

const ColorsContainer = styled.div`
	height: fit-content;
`;

const MenuFooter = styled.div`
	border-top: 1px solid #f0f0f0;
`;

const PopOverCustom = styled(Popover)`
	padding: 1rem;
	min-width: 261px;

	.popover-header {
		padding: 0.2rem 0.3rem;
		background-color: #ffffff;
	}
	.popover-body {
		max-height: 300px;
		overflow: auto;
	}
	/* .popover-arrow {
		display: none;
	} */
`;
